import { useMemo } from "react";
import {
  Typography,
  useDataGrid,
  DataGrid,
  List,
  itIT,
} from "@pankod/refine-mui";
import { EditButton, DeleteButton, Stack } from "@pankod/refine-mui";

function ProductCategoryList() {
  const columns = useMemo(
    () => [
      { field: "id", headerName: "ID" },
      {
        field: "name",
        headerName: "Nome Categoria",
        flex: 1,
        minWidth: 300,
      },
      {
        headerName: "Actions",
        field: "actions",
        minWidth: 50,
        renderCell: function render(params) {
          return (
            <Stack direction="row" spacing={1}>
              <EditButton hideText recordItemId={params.row.id} />
              <DeleteButton hideText recordItemId={params.row.id} />
            </Stack>
          );
        },
      },
    ],
    []
  );

  const { dataGridProps } = useDataGrid();

  return (
    <List
      resource="product-categories"
      createButtonProps={{ size: "small" }}
      headerProps={{
        title: <Typography variant="h5">Categorie di prodotto</Typography>,
      }}
    >
      <DataGrid
        {...dataGridProps}
        columns={columns}
        autoHeight
        localeText={itIT.components.MuiDataGrid.defaultProps.localeText}
      />
    </List>
  );
}

export default ProductCategoryList;
